module.exports = __webpack_public_path__ + "media/images/athletes/1897-8db906cfbb841db7303cf2a179d0e3ae.png";